module.exports = __webpack_public_path__ + "static/media/avatar.458fab12.jpg";